import api, { plainApi } from './axios';
import { RegisterRequest, LoginRequest, AuthResponse } from '../types/auth';

export const register = (data: RegisterRequest) => api.post<AuthResponse>('/api/auth/register', data);

export const login = (data: LoginRequest) => api.post<AuthResponse>('/api/auth/login', data);

// refresh must be called with credentials and no body; use plainApi to avoid interceptor recursion
export const refresh = () => plainApi.post<AuthResponse>('/api/auth/refresh');

export const logout = () => api.post('/api/auth/logout');

export const logoutAll = () => api.post('/api/auth/logout-all');

export const whoami = () => api.get('/whoami');

export const healthCheck = () => api.get('/health');